import { DateTime } from 'luxon'

export const formatAsLocalTime = utcDate => DateTime.fromISO(utcDate, { zone: 'utc' }).setZone(Intl.DateTimeFormat().resolvedOptions().timeZone).toFormat('dd/LL/yyyy, h:mm a')
